import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Block1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M8.71 2.36a.75.75 0 0 1 .65 0L15 5.474c.24.133.341.39.302.627l-.003 5.956a.75.75 0 0 1-.274.543l-.089.065-5.66 3.36a.6.6 0 0 1-.517.046l-.098-.048-5.65-3.396a.75.75 0 0 1-.339-.514L2.66 12V6l.006-.088a1 1 0 0 1 .023-.097l.008-.024a1 1 0 0 1 .027-.063l.011-.02q.016-.03.037-.059l.012-.014a1 1 0 0 1 .049-.058l.014-.012a.6.6 0 0 1 .127-.092l-.075.047.046-.031.029-.016ZM3.86 7.02l-.001 4.716 4.538 2.727-.016-4.925zm10.24.002L9.58 9.527l.017 4.912 4.503-2.672zM9.032 3.548 4.505 6.006l4.466 2.487 4.499-2.492z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Block1$1 = Svg18Block1;

export { Svg18Block1$1 as default };
